import { getElectronAPI } from "@/plugins/desktop";
import etiqueta from "../../../../electron/shared/balancaEtiqueta";

const { normalizarConfiguracao } = etiqueta;
const STORAGE_KEY = "balanca_etiqueta_config";

function dadosRemotos(config = {}) {
  config = config || {};
  const campos = [
    "usar_codigo_balanca",
    "balanca_etiqueta_tipo",
    "balanca_tamanho_codigo_produto",
    "balanca_casas_decimais",
  ];
  return Object.fromEntries(
    campos.filter((campo) => config[campo] !== null && config[campo] !== undefined)
      .map((campo) => [campo, config[campo]])
  );
}

function mesclar(local, remoto) {
  const dados = dadosRemotos(remoto);
  return normalizarConfiguracao({
    ...local,
    ...(dados.usar_codigo_balanca !== undefined ? { habilitada: dados.usar_codigo_balanca } : {}),
    ...(dados.balanca_etiqueta_tipo !== undefined ? { tipo: dados.balanca_etiqueta_tipo } : {}),
    ...(dados.balanca_tamanho_codigo_produto !== undefined
      ? { tamanhoCodigoProduto: dados.balanca_tamanho_codigo_produto } : {}),
    ...(dados.balanca_casas_decimais !== undefined
      ? { casasDecimais: dados.balanca_casas_decimais } : {}),
  });
}

const BalancaEtiquetaService = {
  normalizar: normalizarConfiguracao,
  mesclar,

  async carregarLocal() {
    const api = getElectronAPI();
    try {
      const armazenado = api?.config
        ? await api.config.get(STORAGE_KEY)
        : (typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null);
      return normalizarConfiguracao(armazenado ? JSON.parse(armazenado) : {});
    } catch (_) {
      return normalizarConfiguracao();
    }
  },

  async salvarLocal(config) {
    const normalizada = normalizarConfiguracao(config);
    const api = getElectronAPI();
    if (api?.config) {
      await api.config.set(STORAGE_KEY, JSON.stringify(normalizada));
    } else if (typeof window !== "undefined") {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizada));
      } catch (_) { /* A configuração remota continua disponível. */ }
    }
    return normalizada;
  },

  async carregarConfiguracao(http) {
    const local = await this.carregarLocal();
    if (!http) return local;
    try {
      const response = await http.post("/configuracoesgerais/find");
      const remoto = Array.isArray(response.data) ? response.data[0] : response.data;
      const config = mesclar(local, remoto);
      try {
        await this.salvarLocal(config);
      } catch (_) { /* A leitura remota ainda pode ser usada nesta venda. */ }
      return config;
    } catch (_) {
      return local;
    }
  },
};

export default BalancaEtiquetaService;
